import { en } from './en';
import { ru } from './ru';
import { ua } from './ua'

export const translations = { en, ru, ua };
